import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import AutoInput from "../containers/AutoInput";
import { Button } from 'antd';
class ItemCreate extends Component {
  constructor(props) {
    super(props); 

    this.state = {};
  }

  handleDownloadLayout = () => {
    const keys = {
        description: 'string - required',
        htsCode: 'string - required',
        weight: 'string - required',
        packages: 'string - required',
        value: 'string - required',
        comments: 'string - required',
        damaged: 'string - required',
        hazmat: 'number (0 or 1)',
        satCode: 'string - required',
        materialCode: 'string - required',
        hazmatCode: 'string - required only if hazmat value is 1',
        packaging: 'string',
        packagingDescription: 'string',
        productType: 'string - required'
    }
    let headers = [Object.keys(keys).join(',')];

    let itemCsv = [keys].reduce((acc, item) => {
      acc.push(Object.values(item).join(','))
      return acc
    }, [])
    const blob = new Blob([[...headers, ...itemCsv].join('\n')], { type: 'text/json' })

    const a = document.createElement('a')
    a.download = 'layout.csv'
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  };

  render() {
    return (
      <Fragment>
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          value={this.props.belongsTo.id}
          attribute={"id"}
          type={"number"}
          hidden
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          id={this.props.id}
          attribute={"files"}
          multiple={true}
          accept={".csv"}
          maxCount={1}
        />
        <Button
          style={{ float: 'right', marginRight: '1em' }}
          onClick={this.handleDownloadLayout}>Descargar Plantilla</Button>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(ItemCreate);



// WEBPACK FOOTER //
// ./src/forms/ItemCreate.js